import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
import { DialogContentText, Divider, Link } from "@mui/material";
import { useLocation } from "wouter";
export function AuthenticationInfo() {
    const [, setLocation] = useLocation();
    return (_jsxs(_Fragment, { children: [_jsx(Divider, { variant: "middle", sx: { my: 2 } }), _jsxs(DialogContentText, Object.assign({ variant: "caption", textAlign: "center" }, { children: ["By continuing, you agree to the", " ", _jsx(Link, Object.assign({ component: "button", variant: "caption", sx: { color: "rgba(0, 0, 0, 0.6)" }, onClick: () => {
                            setLocation("/docs/termsofuse");
                        } }, { children: "Terms of Use" })), " ", "and", " ", _jsx(Link, Object.assign({ component: "button", variant: "caption", sx: { color: "rgba(0, 0, 0, 0.6)" }, onClick: () => {
                            setLocation("/docs/privacypolicy");
                        } }, { children: "Privacy Policy" })), " ", "."] }))] }));
}
